import React, { useState } from 'react';
import styles from './asset/userInforHolder.module.scss';
import EditProfileModal from './EditProfileModal/EditProfileModal';
import { useSelector } from 'react-redux';
import { usersData$ } from '../../reduxStore/selectors/userSelectors';

const UserInfoHolder = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const userData = useSelector(usersData$) || {};
    const { username, email, job, avatar } = userData;
    const avatarSrc = avatar || require("../../publicAsset/media/Prepal Logo 3.svg").default;

    return (
        <div className={styles.frameParent}>
            <div className={styles.frameGroup}>
                <div className={styles.usersParent}>
                    <div className={styles.users}>
                        <div className={styles.colorBg} />
                        <img className={styles.philipMartin5aguycwPjwUnspIcon} alt="User Avatar" src={avatarSrc} />
                    </div>
                </div>
                <div className={styles.hoaTruongParent}>
                    <div className={styles.hoaTruong} data-full-text={username}>
                        <span>{username}</span>
                    </div>
                    <div className={styles.emailHoatruonggmailcomParent}>
                        <div className={styles.hoaTruong} data-full-text={`Email: ${email}`}>
                            <span>Email: {email}</span>
                        </div>
                        <div className={styles.hoaTruong} data-full-text={`Job: ${job}`}>
                            <span>Job: {job}</span>
                        </div>
                        <div className={styles.frameContainer}>
                            <div className={styles.satWrapper}>
                                <div className={styles.sat}>SAT</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.editEditPencilLine02Parent} onClick={() => setModalOpen(true)} style={{ cursor: 'pointer' }}>
                <svg className={styles.editEditPencilLine021} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.1667 2.49993C14.3856 2.28106 14.6454 2.10744 14.9314 1.98899C15.2173 1.87054 15.5238 1.80957 15.8334 1.80957C16.1429 1.80957 16.4494 1.87054 16.7353 1.98899C17.0213 2.10744 17.2811 2.28106 17.5 2.49993C17.7189 2.7188 17.8925 2.97863 18.011 3.2646C18.1294 3.55057 18.1904 3.85706 18.1904 4.16659C18.1904 4.47612 18.1294 4.78262 18.011 5.06859C17.8925 5.35455 17.7189 5.61439 17.5 5.83326L6.25004 17.0833L1.66671 18.3333L2.91671 13.7499L14.1667 2.49993Z" stroke="currentColor" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <div className={styles.sat}>Edit profile</div>
            </div>
            <EditProfileModal open={modalOpen} onClose={() => setModalOpen(false)} user={userData} />
        </div>
    );
};

export default UserInfoHolder;
